import { GridRowId, GridRowSelectionModel } from '@mui/x-data-grid-pro'
import { uniq } from 'ramda'
import { PropsWithChildren, ReactNode, useMemo, useState } from 'react'
import { useBatchedFields } from '../../../queries'
import { FieldSelectionContext } from './FieldSelectionContext'

type FieldSelectionProviderProps = {
  children?: ReactNode
}

export const FieldSelectionProvider = ({
  children,
}: PropsWithChildren<FieldSelectionProviderProps>) => {
  const [selectionModel, setSelectionModel] = useState<GridRowSelectionModel>({
    type: 'include',
    ids: new Set(),
  })

  const clearSelectionModel = () => selectionModel?.ids.clear()

  const selectedRowIds = useMemo(
    () => Array.from(selectionModel?.ids.values()),
    [selectionModel.ids]
  )
  const fields = useBatchedFields(selectedRowIds as string[])

  const handleDeselectRowIds = (ids: GridRowId[]) => {
    ids.forEach(id => selectionModel.ids.delete(id))
  }

  const selectedFields = fields.data?.filter(Boolean) || []

  const selectionOwnedByUsers = uniq(
    selectedFields ? selectedFields.filter(Boolean).map(f => f.ownedBy?.userId) : []
  )

  return (
    <FieldSelectionContext.Provider
      value={{
        selectedFields,
        selectionModel,
        setSelectionModel,
        selectedRowIds,
        deselectRowIds: handleDeselectRowIds,
        clearSelectionModel,
        selectionOwnedByUsers,
      }}
    >
      {children}
    </FieldSelectionContext.Provider>
  )
}
